import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../../../common/utils/logger';

export const onAddPin: (
	nonPrivacySafeAttributes: {
		title: string;
		url: string;
		keyPhrases: string[];
		description: string | undefined;
	},
	source: string,
) => AnalyticsEventPayload = (
	nonPrivacySafeAttributes: {
		title: string;
		url: string;
		keyPhrases: string[];
		description: string | undefined;
	},
	source: string,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubject: 'aiSearchBookmarkAddButton',
			eventType: 'ui',
			nonPrivacySafeAttributes,
			source,
		};
	} catch (error) {
		logger.error({ error, functionName: 'onAddPin' });
		return {};
	}
};
